"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const brand = "#F6323E"; // light red
const headerBackgroundColor = "#D8E5DF"; // light green
const headerTextColor = brand;
const appAccentColor = brand;
const mainInfoLandscape = headerTextColor;
const mainInfoPortrait = headerTextColor;
const style = "normal";
const colorAppBar = "#D8E5DF";
const colorOnAppBar = "#F6323E";
const colorPrimary = "#D8E5DF";
const colorPrimaryDarker = "#95b8a8";
const colorPrimaryLighter = "#f7faf9";
const colorOnPrimary = "#F6323E";
const colorSecondary = "#F6323E";
const colorOnSecondary = "#D8E5DF";
const colorTiles = ["#D8E5DF", "#D8E5DF", "#D8E5DF"];
exports.default = {
    brand,
    mainInfoLandscape,
    mainInfoPortrait,
    headerBackgroundColor,
    headerTextColor,
    appAccentColor,
    style,
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
